import { Component } from 'react';
import Header from '../../../Header';
import Footer from '../../../Footer';
import ConselhoDeliberativo from '../../../Conselho/Deliberativo';
import ConselhoFiscal from '../../../Conselho/Fiscal';
import Lgpd from '../../../Lgpd';
import ErrorBoundary from '../../../ErrorHandler/ErrorBoundary';
import InfoComponent from '../../InfoComponent';

class Conselhos extends Component {
	render() {
		return (
			<div>
				{/* HEADER */}{/* LOGIN */}
				<ErrorBoundary><Header /></ErrorBoundary>
				<main>
					<InfoComponent image={"conselhos"} page={'conselhos'}></InfoComponent>
					{/* Content page */}
					<div className="_the-content page-conselhos pb-10">
						<div className="container">
							<div className="row justify-content-center align-items-center">
								<div className="col-lg-10">

									<ErrorBoundary><ConselhoDeliberativo /></ErrorBoundary>
									<br /><br />
									<ErrorBoundary><ConselhoFiscal /></ErrorBoundary>

								</div>
							</div>
						</div>
					</div>
				</main>
				{/* FOOTER */}
				<ErrorBoundary>	<Footer /></ErrorBoundary>
				{/* LGPD */}
				<ErrorBoundary><Lgpd /></ErrorBoundary>
			</div>
		);
	}
};

export default Conselhos;